import { IAssociationLogo } from '..';

export interface IUpdateAssociationLogos {
    items: AssociationLogoUpdateItem[];
}
export type AssociationLogoUpdateItem = Pick<IAssociationLogo, 'url' | 'name' | 'show' | 'image_url' | 'image'>;
